// extracted by mini-css-extract-plugin
export default {"loadingIndex":"Loading_loadingIndex__sa379"};